$.extend(true, BT, {
  initTabAccordion: function() {
    $(document).on('click', '.tab-accordion__trigger', (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass('working')) {
        return;
      }
      btn.addClass('working');
      const newTabPane = $(btn.attr('href'));
      btn.toggleClass('open');
      
      if(btn.hasClass('open')) {
        newTabPane.slideDown(300, () => {
          btn.removeClass('working');
        });
      } else {
        newTabPane.slideUp(300, () => {
          btn.removeClass('working');
        });
      }
    });
    $(document).on('shown.bs.tab', '.tab-accordion-list a[data-toggle="tab"]', (e) => {
      const href = $(e.currentTarget).attr('href');
      const tabPane = $(href);
      tabPane.addClass('open').show();
      tabPane.siblings('.tab-accordion__trigger[href="' + href + '"]').addClass('open');
    });
    $(document).on('hidden.bs.tab', '.tab-accordion-list a[data-toggle="tab"]', (e) => {
      const href = $(e.currentTarget).attr('href');
      const tabPane = $(href);
      tabPane.removeClass('open').hide();
      tabPane.siblings('.tab-accordion__trigger[href="' + href + '"]').removeClass('open');
    });
  }
});
class MainProductTabsSection extends BTSection {
  onLoad(evt) {
    BT.runReLoadReview(this.container, true);
    BT.rteWrap(this.container.find('.rte'));
  }
  onBlockSelect(evt) {
    const tab = $(evt.target);
    let tabNav;
    if(BT.data.cacheWindowWidth <= 991) {
      tabNav = $('.tab-accordion__trigger[href="#' + tab.attr('id') + '"]');
      if(!tabNav.hasClass('open')) {
        tabNav.trigger('click');
      }
    } else {
      tabNav = $('.nav__link-single[href="#' + tab.attr('id') + '"]');
      if(!tabNav.parent().hasClass('active')) {
        tabNav.trigger('click');
      }
    }
    if(!BT.isInViewport(tabNav, evt.currentTarget.defaultView)) {
      const offset = tabNav.offset().top - 100;
      $('html, body').animate({
        scrollTop: offset
      }, 400);
    }
  }
}
BT.initTabAccordion();
theme.sections.constructors['main-product-tabs'] = MainProductTabsSection;